import FJConfig from '../../config/FJConfig';
import FJConstant from '../../constants/FJConstant';
import FJUtil from '../../util/FJUtil';
import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJCloudTranscodingUtil from '../../util/FJCloudTranscodingUtil';

import {
    setSliceWarningModalData,
    setSlicePreviewModalData,
    setSliceImagePreviewModalData,
    setSliceImageCropModalData,
    setSliceUpgradeModalData,
    setSliceUploadImageAsPromptModalData,
    setSliceAddAsEditPageModalBtuStatus,
    setSliceMobilePreviewData,
    setGlobalLoadingDisplay,
    setMobileSimplePreviewData,
    setSliceIsShowRecordDisplay,
    setAutoSelectionNoticeDisplay,
    setVideoTrimModelData,
    setServerBusyModalData,
    setAnimateImageModalDisplay,
    setTimeDiscountPanelData,
    setSliceLoadingModalData,
    setMediaPreviewData,
    setSliceDoNotShowAgainData,
    setCloudTranscodingModalData,
    setSliceDetailsPreviewModalData,
    setSliceReportModalData,
} from '../slices/FJSliceModals';
import FJAppConstant from '../../constants/FJAppConstant.js';
import FJActionCommon from './FJActionCommon.js';
import FJActionRecord from './FJActionRecord.js';
import FJKeymap from '../../util/FJKeymap.js';
import FJActionCloudTranscoding from './FJActionCloudTranscoding.js';
import FJDropDownManager from '../../common/js/FJDropDownManager.js';

export default {
    showWarningModalAction: function (data) {
        return dispatch => {
            dispatch(setSliceWarningModalData({ ...data, display: true }));
        };
    },
    hideWarningModalAction: function () {
        return (dispatch, getState) => {
            const warningModalData = getState().modals.warningModalData;
            dispatch(setSliceWarningModalData({ ...warningModalData, display: false }));
        };
    },
    showReportModalAction: function (data) {
        return dispatch => {
            dispatch(setSliceReportModalData({ display: true, data }));
        };
    },
    hideReportModalAction: function () {
        return dispatch => {
            dispatch(setSliceReportModalData({ display: false }));
        };
    },
    showDetailsPreviewModalDataAction: function (option) {
        return dispatch => {
            dispatch(setSliceDetailsPreviewModalData({ ...option, display: true }));
            FJKeymap.setScope('modal');
        };
    },
    hideDetailsPreviewModalDataAction: function () {
        return dispatch => {
            dispatch(setSliceDetailsPreviewModalData({ display: false }));
            FJKeymap.setScope('default');
        };
    },

    showPreviewModalDataAction: function (option) {
        return dispatch => {
            if (FJUtil.isMobile()) {
                dispatch(setSliceMobilePreviewData({ ...option, display: true }));
            } else {
                dispatch(setSlicePreviewModalData({ ...option, display: true }));
            }
            FJKeymap.setScope('modal');
        };
    },
    hidePreviewModalDataAction: function () {
        return dispatch => {
            if (FJUtil.isMobile()) {
                dispatch(setSliceMobilePreviewData({ display: false }));
            } else {
                dispatch(setSlicePreviewModalData({ display: false }));
            }
            FJKeymap.setScope('default');
        };
    },
    /**
     * 显示图片裁剪模态框
     * @param {*} input 输入的图片
     * @param {*} onConfirm 确认回调
     * @param {*} onCancel 取消回调
     * @param {*} options { inputType = 'file', ... } 输入类型
     * @returns
     */
    showImageCropModalAction: function (input, onConfirm, onCancel, options) {
        const { inputType = 'file' } = options;
        return dispatch => {
            let imageUrl = null;
            switch (inputType) {
                case 'file':
                    imageUrl = input ? URL.createObjectURL(input) : '';
                    break;
                case 'url':
                    imageUrl = input;
                    break;
            }
            dispatch(
                setSliceImageCropModalData({
                    imageUrl,
                    display: true,
                    onConfirm: onConfirm || null,
                    onCancel: onCancel || null,
                    inputType: inputType || 'file',
                    ...options,
                }),
            );
            FJKeymap.setScope('modal');
        };
    },
    hideImageCropModalAction: function () {
        return dispatch => {
            dispatch(setSliceImageCropModalData({ display: false }));
            FJKeymap.setScope('default');
        };
    },
    showUpgradeModalAction: function () {
        return dispatch => {
            // if (FJUtil.isMobile()) {
            //     dispatch(setSliceUpgradeModalData({ display: true }));
            // } else {
            //     // pc端直接弹购买弹窗
            //     dispatch(FJActionCommon.getCreditsAction());
            // }
            dispatch(FJActionCommon.getCreditsAction());
        };
    },
    hideUpgradeModalAction: function () {
        return dispatch => {
            dispatch(setSliceUpgradeModalData({ display: false }));
        };
    },

    addAsEditPageAction: function (idList, callback = () => {}, options = {}) {
        return async (dispatch, getState) => {
            const { appType: tempAppType, previewList: tempPreviewList } = options;
            dispatch(setSliceAddAsEditPageModalBtuStatus(FJConstant.LOADING));
            callback(FJConstant.LOADING);
            const { historyList: reducerHistoryList, appType: reducerAppType } = getState().common;

            const appType = tempAppType || reducerAppType;
            const historyList = tempPreviewList || reducerHistoryList;

            const __getRandomName = () => {
                // 生成随机字符串 用纯数字
                return Math.random().toString(36).substring(2, 15);
            };

            // safari 兼容，safari 不支持异步打开新窗口会被认为是广告而拦截
            // 通过同步方式打开再异步设置 href
            const newTab = window.open('', '_blank');
            try {
                const tool = FJUtil.getToolName();
                FJUtil.eaLog('ai tool make video click', { tool });

                const itemList = historyList.filter(item => idList.includes(item.id));

                const isVideo =
                    appType === FJAppConstant.AI_VIDEO_GENERATOR ||
                    appType === FJAppConstant.VIDEO_REMOVE_BG ||
                    appType === FJAppConstant.AI_VIDEO_DUB;
                const isAudioGenerator = appType === FJAppConstant.AI_AUDIO_GENERATOR;
                const isWebm = appType === FJAppConstant.VIDEO_REMOVE_BG;

                let blobList = [];
                if (isVideo) {
                    blobList = await Promise.all(
                        itemList.map(async item => {
                            const blob = await FJUtil.downloadVideoCacheAvoidance(item.videoUrl);
                            if (!blob) throw new Error('network error');
                            return blob;
                        }),
                    );
                    if (blobList.length === 0) throw new Error('network error');

                    if (isWebm) {
                        blobList = blobList.map(blob => new Blob([blob], { type: 'video/webm' }));
                        blobList.forEach(blob => {
                            blob.name = new Date().getTime() + '.webm';
                        });
                    } else {
                        blobList = blobList.map(blob => new Blob([blob], { type: 'video/mp4' }));
                        blobList.forEach(blob => {
                            blob.name = new Date().getTime() + '.mp4';
                        });
                    }
                } else if (isAudioGenerator) {
                    blobList = await Promise.all(
                        itemList.map(async item => {
                            const blob = await FJUtil.downloadVideoCacheAvoidance(item.audioUrl);
                            if (!blob) throw new Error('network error');
                            return blob;
                        }),
                    );
                    if (blobList.length === 0) throw new Error('network error');
                    blobList = blobList.map(blob => new Blob([blob], { type: 'audio/mpeg' }));
                    blobList.forEach((blob, index) => {
                        blob.name = FJUtil.getUseFileName(itemList[index].audioName, '.mp3');
                    });
                } else {
                    blobList = await Promise.all(
                        itemList.map(async item => {
                            const blob = await FJUtil.downloadImageCacheAvoidance(item.imgUrl);
                            if (!blob) throw new Error('network error');
                            return blob;
                        }),
                    );
                    if (blobList.length === 0) throw new Error('network error');

                    blobList.forEach(blob => {
                        blob.name = __getRandomName() + '.png';
                    });
                }

                const _jumpUrl = uploadKey => {
                    const url = FJUtil.getCurrentUrl() + 'editor/app?rec_id=' + uploadKey;
                    // 异步设置 href
                    newTab.location.href = url;
                };
                FJUtil.readFiles(
                    blobList,
                    {
                        module: 'media',
                        isAddToPip: appType === FJAppConstant.VIDEO_REMOVE_BG,
                    },
                    _jumpUrl,
                );
            } catch (error) {
                console.error(error);
                newTab.close();
            } finally {
                dispatch(setSliceAddAsEditPageModalBtuStatus(FJConstant.SUCCESS));
                callback(FJConstant.SUCCESS);
            }
        };
    },
    shareToSocietyAction: function (id, type) {
        return (dispatch, getState) => {
            // facebook分享页面：https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.flexclip.com%2F
            // twitter: https://twitter.com/intent/tweet?url=https%3A%2F%2Fwww.smartvideomaker.com%2F
            // linkin: https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fwww.smartvideomaker.com%2F
            // tumblr: https://www.tumblr.com/widgets/share/tool?posttype=link&canonicalUrl=https%3A%2F%2Fwww.smartvideomaker.com%2F
            const { historyList } = getState().common;
            const item = historyList.find(item => item.id === id);
            const tool = FJUtil.getToolName();
            const buryData = {
                tool,
                share: type.toLowerCase(),
            };
            FJUtil.eaLog('ai tool share click', buryData);
            const shareLink = FJUtil.getShareLink(item?.shareKey);
            shareLink && FJUtil.shareToSociety(type, shareLink);
        };
    },

    showUploadImageAsPromptModalAction: function () {
        return dispatch => {
            dispatch(setSliceUploadImageAsPromptModalData({ display: true }));
        };
    },
    hideUploadImageAsPromptModalAction: function () {
        return dispatch => {
            dispatch(setSliceUploadImageAsPromptModalData({ display: false }));
        };
    },

    showGlobalLoadingAction: function () {
        return dispatch => {
            dispatch(setGlobalLoadingDisplay(true));
        };
    },
    hideGlobalLoadingAction: function () {
        return dispatch => {
            dispatch(setGlobalLoadingDisplay(false));
        };
    },
    showMobileSimplePreviewModalAction: function (data) {
        return dispatch => {
            dispatch(setMobileSimplePreviewData({ data, display: true }));
        };
    },
    hideMobileSimplePreviewModalAction: function () {
        return dispatch => {
            dispatch(setMobileSimplePreviewData({ display: false }));
        };
    },
    /**
     *  账号变更提示
     * @returns
     */
    accountChangesModalAction: function () {
        return dispatch => {
            dispatch(
                this.showWarningModalAction({
                    title: FJLocalStore._('account-changes'),
                    content: FJLocalStore._(
                        'the-current-account-has-been-changed-continuing-will-refresh-the-page-and-the-current-uploads-and-settings-will-not-be-retained',
                    ),
                    footerDates: [
                        {
                            btnType: FJConstant.WARNING,
                            btnText: FJLocalStore._('continue'),
                            btnCallback: async () => {
                                location.reload();
                            },
                        },
                        {
                            btnType: FJConstant.CANCEL,
                            btnText: FJLocalStore._('cancel'),
                            btnCallback: null,
                        },
                    ],
                }),
            );
        };
    },

    /**
     * @description 在声音克隆中打开录音面板
     * @returns {(function(*))|*}
     */
    showRecordModalInCreateCloneAction: function () {
        return dispatch => {
            FJUtil.setRecordVoiceType(FJConstant.RECORD_IN_CREATE_CLONE);
            dispatch(this.showRecordModalAction());
        };
    },

    showRecordModalAction: function () {
        return dispatch => {
            dispatch(FJActionRecord.initRecorderAction());
            dispatch(setSliceIsShowRecordDisplay(true));
        };
    },

    hideRecordModalAction: function () {
        return dispatch => {
            dispatch(setSliceIsShowRecordDisplay(false));
            FJActionRecord.stopPreviewRecorder();
            dispatch(FJActionRecord.stopRecorderAction(true));
        };
    },
    showAutoSelectionNoticeModalAction: function () {
        return dispatch => {
            dispatch(setAutoSelectionNoticeDisplay(true));
        };
    },
    hideAutoSelectionNoticeModalAction: function () {
        return dispatch => {
            dispatch(setAutoSelectionNoticeDisplay(false));
        };
    },

    showVideoTrimModalAction: function (data) {
        return dispatch => {
            dispatch(setVideoTrimModelData({ display: true, data }));
        };
    },

    hideVideoTrimModalAction: function () {
        return dispatch => {
            dispatch(setVideoTrimModelData({ display: false, data: { src: '', width: 0, height: 0, duration: 0 } }));
        };
    },
    showServerBusyModalAction: function () {
        return dispatch => {
            dispatch(setServerBusyModalData({ display: true }));
        };
    },

    hideServerBusyModalAction: function () {
        return dispatch => {
            dispatch(setServerBusyModalData({ display: false }));
        };
    },
    showAnimateImageModalAction: function () {
        return dispatch => {
            const key = 'animateImageModalShowed' + FJUtil.getUserId();
            const isShowed = window.localStorage.getItem(key) === 'showed';
            if (!isShowed) {
                window.localStorage.setItem(key, 'showed');
                dispatch(setAnimateImageModalDisplay(true));
            }
        };
    },
    hideAnimateImageModalAction: function () {
        return dispatch => {
            dispatch(setAnimateImageModalDisplay(false));
        };
    },

    setTimeDiscountPanelDataAction: function (visible) {
        return dispatch => {
            dispatch(setTimeDiscountPanelData({ visible: visible }));
        };
    },
    showGenerateLoadingModalAction: function (message) {
        return dispatch => {
            dispatch(setSliceLoadingModalData({ display: true, message }));
        };
    },
    hideGenerateLoadingModalAction: function () {
        return dispatch => {
            dispatch(setSliceLoadingModalData({ display: false }));
        };
    },
    showMediaPreviewAction: function (data) {
        return dispatch => {
            dispatch(setMediaPreviewData({ ...data, active: true }));
        };
    },
    closeMediaPreviewAction: function () {
        return dispatch => {
            dispatch(setMediaPreviewData({ active: false }));
        };
    },
    showDoNotShowAgainModalAction: function (data) {
        return dispatch => {
            setTimeout(() => dispatch(setSliceDoNotShowAgainData({ ...data, display: true })), 100);
        };
    },
    hideDoNotShowAgainModalAction: function () {
        return (dispatch, getState) => {
            const doNotShowAgainData = getState().modals.doNotShowAgainData;
            dispatch(setSliceDoNotShowAgainData({ ...doNotShowAgainData, display: false }));
        };
    },
    showImagePreviewModalAction: function (imageList, currentIndex = 0, options = {}) {
        return dispatch => {
            dispatch(
                setSliceImagePreviewModalData({
                    display: true,
                    imageList,
                    currentIndex,
                    ...options,
                }),
            );
            FJKeymap.setScope('modal');
        };
    },
    hideImagePreviewModalAction: function () {
        return dispatch => {
            dispatch(setSliceImagePreviewModalData({ display: false }));
            FJKeymap.setScope('default');
        };
    },
    showCloudTranscodingModalAction: function (config = {}) {
        return async dispatch => {
            return new Promise((resolve, reject) => {
                let files = config.files;
                const isLogin = FJUtil.isLogin();
                if (!isLogin) {
                    FJUtil.login();
                    dispatch(this.hideCloudTranscodingModalAction());
                    reject();
                    return;
                }

                // 在弹窗弹出前检查媒体类型匹配
                const { mediaType = 'video' } = config;
                const mediaTypeMismatchFiles = [];
                files.forEach(file => {
                    const detectedMediaType = FJCloudTranscodingUtil.detectMediaType(file);
                    if (detectedMediaType !== mediaType) {
                        mediaTypeMismatchFiles.push(file);
                    }
                });

                // 如果所有文件的媒体类型都不匹配，直接reject跳过转码
                if (mediaTypeMismatchFiles.length === files.length) {
                    reject({ files, isAllFailed: true, cause: FJConstant.INVALID });
                    return;
                }

                // 重置转码状态
                dispatch(FJActionCloudTranscoding.resetTranscodingStateAction());

                const {
                    outputFormat = 'mp4',
                    inputOptions = {
                        accept: 'image/*',
                        multiple: false,
                    },
                    onReupload,
                } = config;

                // 构建转码选项
                const transcodingOptions = {
                    mediaType,
                    outputFormat,
                };

                // 显示Modal并保存所有配置
                dispatch(
                    setCloudTranscodingModalData({
                        display: true,
                        inputOptions,
                        onConfirm: transcodedFiles => resolve({ files: transcodedFiles }),
                        onCancel: () => reject({ files: files, isAllFailed: false, cause: FJConstant.CANCELLED }),
                        onReupload,
                    }),
                );

                dispatch(
                    FJActionCloudTranscoding.setCloudTranscodingCallbacksAction({
                        onSuccess: successTasks => {
                            resolve({
                                files: successTasks.map(task => task.file),
                            });
                        },
                        onError: (failTasks, cause) => {
                            reject({
                                files: failTasks.map(task => task.file),
                                cause,
                            });
                        },
                    }),
                );
                dispatch(FJActionCloudTranscoding.updateTranscodingConfigAction(transcodingOptions));
                dispatch(FJActionCloudTranscoding.batchCloudTranscodeFilesAction(files, transcodingOptions));
            });
        };
    },
    hideCloudTranscodingModalAction: function () {
        return dispatch => {
            dispatch(setCloudTranscodingModalData({ display: false, visible: false }));
        };
    },
};
